<form *ngIf="fields" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="addEditFormTypes" (ngSubmit)="saveOrUpdate()" RestrictFocus>
    <div class="ui-grid ui-grid-responsive ui-fluid">
        <div class="ui-grid-row bottom-10-margin">
            <div class="ui-grid-col-4">
              <label class="label" [ngClass]="{'required': !fields.name.nullable}">
                {{ fields.name.keyName }}
              </label>
            </div>
            <div class="ui-grid-col-8">
              <input type="text" formControlName="name" pInputText/>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditFormTypes" [validation]="fields.name"></app-validation-msg>
            </div>
        </div>
    </div>
    <p-footer>
        <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="border: 0; text-align: center;">
            <button
              class="k-generic-btn" type="submit"
              pButton
              icon="fa fa-check"
              [label]="'common.save' | translate">
            </button>
        </div>
    </p-footer>
</form>



// WEBPACK FOOTER //
// ./src/app/views/classification-types/classification-types-form.component.html